import { client } from "@/generated/ui-api/client.gen";
import { getRuntimeConfig } from "@/loadConfig";
import i18n from "@/i18n";

type RuntimeCfg = { "api-base-url"?: string };
let configured = false;

export function configureClient(overrides?: { baseUrl?: string }) {
  if (configured) return client;

  const cfg = getRuntimeConfig<RuntimeCfg>();
  const baseUrl =
    overrides?.baseUrl ??
    cfg?.["api-base-url"] ??
    import.meta.env["api-base-url"] ??
    "/ui/api";

  client.setConfig({
    baseUrl,
    credentials: "include",
  });

  client.interceptors.request.use(request => {
    const locale = i18n.language || "LT";
    request.headers.set("Accept-Language", locale);

    return request;
  });

  configured = true;

  return client;
}

// 2) re-export the *flat* SDK functions and types so app code imports from here
export * from "@/generated/ui-api/sdk.gen";
export * from "@/generated/ui-api/types.gen";
